import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

export const GetVendorsBIZcorePay = (companyId, health, page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getVendorsBIZcorePay(companyId, health, page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_VENDORS_BIZ_CORE_PAY, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetVendorsAnalyticsBIZcorePay = (companyId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getVendorsAnalyticsBIZcorePay(companyId);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_VENDORS_ANALYTICS_BIZ_CORE_PAY, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

// Clears flags that no longer match the configuration on file. Resolves with
// the repair summary so the page can report exactly what was changed.
export const RepairVendorsBIZcorePay = (companyId, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.repairVendorsBIZcorePay(companyId);
    if (status === 201) {
      const repaired = data.data?.repaired || 0;
      toast.success(
        repaired === 0
        ? "Nothing to repair — every vendor flag already matches its configuration"
        : `Repaired ${repaired} vendor${repaired === 1 ? "" : "s"}`
      );
      setLoading(false);
      return data.data;
    }
    dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    setLoading(false);
    return null;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};
